export const MAX_CHARACTERS = 6000;
export const MIN_CHARACTERS = 1;

export const MESSAGES = {
  PLACEHOLDER: 'Digite sua resposta aqui...',
  SUBMITTING: 'Enviando...',
  SUBMIT_BUTTON: 'Enviar minha resposta',
  MIN_LENGTH_ERROR: 'Por favor, escreva uma resposta com pelo menos 1 caractere.',
  EVALUATION_ERROR: 'Erro ao avaliar resposta. Por favor, tente novamente.',
  NO_ANSWER: 'Nenhuma resposta fornecida.',
  YOUR_ANSWER: 'Sua resposta:',
} as const;

export const DISAGREE_MESSAGES = {
  BUTTON_TEXT: 'Não concordo com a resposta da IA',
  MODAL_TITLE: 'Não concordo com a resposta da IA',
  MODAL_SUBTITLE: 'Descreva pra gente o seu argumento.',
  PLACEHOLDER: 'A resposta que a IA me trouxe não faz sentido.',
  BACK_BUTTON: 'Voltar',
  SUBMIT_BUTTON: 'Enviar',
  SUBMITTING: 'Enviando...',
  SUCCESS: 'Feedback registrado com sucesso!',
  ERROR: 'Erro ao enviar feedback. Tente novamente.',
  MIN_LENGTH_ERROR: 'Por favor, descreva seu argumento com pelo menos 10 caracteres.',
} as const;

export const DISAGREE_MIN_CHARACTERS = 10;
export const DISAGREE_MAX_CHARACTERS = 500;

export const SCORE_THRESHOLDS = {
  HIGH: 70,
  MEDIUM: 50,
} as const;
